'use strict';

import $ from 'jquery';
import flatpickr  from 'flatpickr';
import rangePlugin  from '../../node_modules/flatpickr/dist/plugins/rangePlugin';


let initialiseFilters = function(container, paginationContainer) {

  // retrieveParams();

  // TODO: get parameters from url, and update filter object, update the select and datepicker display values

  // 1) for all selects
  let selects = container.find('select'),
  option= selects.find('option'),
  formData = new FormData(),
  selectedOption = $('option:selected'),
  $reset = container.find('.btn-filter-reset');

  $reset.on('click', function(e) {
    e.preventDefault();
    $('input[name="startDate"]', container).val('');
    $('input[name="endDate"]', container).val('');
    option.val('');

    $('form').submit();
  })

  selects.on('change', function() {
    let value = $(this).val(),
    name = $(this).attr('name');

    radioPagination.prop('checked', false);
    $('input[value="1"]', pagination).prop('checked', true);

    conductFilter(formData, name, value);

  });

  // if (option.selected == true) {
  //     let value = $(this).val();

  //     console.log($(this));
  // }


  // 2) for all datepickers
  let datePickers = container.find('.flatpickr');

  if (datePickers.length) {

    flatpickr('.flatpickr', {
      // altInput: true,
      // altFormat: "m-d-Y",
      mode: "range",
      dateFormat: 'd-m-Y',
      // plugins: [new rangePlugin({ input: '.flatpickr-enddate'})],
      onClose: function(selectedDates, dateStr, instance) {

        let param = datePickers.attr('name');

        // let dateArr = [$('input[name="startDate"]').val(), $('input[name="endDate"]').val()];
        let dateArr = selectedDates.map(date => this.formatDate(date, "d-m-Y"));;
        // let start = dateArr[0];
        // let end = dateArr[1];

        $('input[name="startDate"]').val(dateArr[0]);
        $('input[name="endDate"]').val(dateArr[1])

        radioPagination.prop('checked', false);
        $('input[value="1"]', pagination).prop('checked', true);

        conductFilter(formData, param, dateArr);
      }
    });

  }

  // 3) for pagination
  let pagination = container.find('.pagination');
  let radioPagination = $('input[type="radio"]', pagination);

  if (pagination.length) {

    radioPagination.on('change', function(e) {
      e.preventDefault();
      let $this= $(this),
      value = $this.val(),
      name = $this.attr('name');

      conductFilter(formData, name, value);
    });
  }
}

//////////

let conductFilter = function(obj, key, value) {

  // obj.set(key, value);

  obj[key] = value;


  $('form').submit();

};

// let retrieveParams = function() {
//     let url = window.location.href;

//     url = url.split('?');


//     // if have params
//     if (url.length > 1) {

//         let params = url[1]; // a=b&b=c...

//         let paramsArray = params.split('&'); // ['a=b', 'b=c']
//         console.log(paramsArray)

//         $.each(paramsArray, function(idx, each) {

//           let param = each.split('='); // ['key', 'value]


//           let key = param[0],
//           value = param[1];

//           console.log(`${key} and ${value}`);

//         let $listingFilterFields = $('.listing-filter__field');

//         // identify if the key belongs to a select element

//         $listingFilterFields.each(function(k, field) {
//             // console.log(field);
//             let $field = $(field);


//             // FOR SELECT

//             if ($field.find('select').length) {
//                 console.log('hello');
//                 let select = $field.find('select'), // the actual <select> element
//                 selectName = select.attr('name'), //selectName is also the id
//                 label = $field.find('.custom-trigger .label'); // the custom trigger's label which is a <span>


//                 if (selectName === key) {

//                     select.val(value);

//                     let optionName = $(`#${selectName} option:selected`).text();

//                     label.text(optionName);

//                 };

//             }

//             // FOR DATEPICKER
//             if ($field.find('.flatpickr').length !== 0) {

//                 // $('#woof').value("03-15-2019 to 03-18-2019");


//                 console.log('inside datepicker')
//                 let inputStart = $field.find('input.flatpickr-startdate').attr('name'),
//                     inputEnd = $field.find('input.flatpickr-enddate').attr('name');

//                 // let startValue = startParam.val(value);
//                 // let endValue = endParam.val(value);
//                 let $this = $(this);
//                 // console.log('hasdjkashdjkas  ashdasjkdhasjk ',key);
//                 // console.log(`inputStart ${value} and inputEnd ${value}`);
//                 if (inputStart == key) {
//                     // console.log('inside if')
//                     // console.log(inputStart + '====' + inputEnd);
//                     // let current = value.join();
//                     // input.val(current);

//                     // console.log(`${inputValue[0]}, ${inputValue[2]}`);

//                     // inputStart.val(inputValue[0]);
//                     // inputEnd.val(inputValue[2]);
//                 }
//             }

//             // FOR PAGINATION
//             if ($field.find('input').length !== 0) {
//                 let input = $field.find('input'),
//                     inputName = input.attr('name'),
//                     inputValue = input.val();

//                 input.each(function () {

//                     if ($(this).val() == value ) {
//                         $(this).prop('checked', true);
//                     }
//                 });
//             };

//         });

//         });
//     }

// }



export { initialiseFilters };
